import { Component, OnDestroy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'btn-cell-renderer-technician-subTask',
    template: `
    <style>
        .edit-btn {
            color: white;
            background: #3aafe4;
            margin-right: 5px;
        }
        .view-btn {
            color: white;
            background: #17a2b8;
            margin-right: 5px;
        }
        .delete-btn {
            color: white;
            background: red;
            margin-right: 5px;
        }
        i {
            color: white;
            padding-bottom: 15px
        }
        .btn:disabled {
            opacity: 0.5;
            cursor: not-allowed;
        }
        .btn {
            padding: 7px 10px;
            border: none;
            border-radius: 5px;
            cursor: pointer;
        }
        .d-flex {
            display: flex;
        }
    </style>
    <div class="d-flex">
        <button class="delete-btn btn custom-tooltip" *ngIf="isDelete" [disabled]="isButtonDisabled(params) || isCompleted" title="Delete" mat-icon-button tooltipPosition="top" (click)="onClickDelete($event)">
            <i class="fa fa-trash" aria-hidden="true"></i>
        </button>

        <button class="view-btn btn custom-tooltip" *ngIf="(isUpdate && (isButtonDisabled(params) || isCompleted)) || fromManager" title="View" mat-icon-button tooltipPosition="top" (click)="onClickView($event)">
            <i class="fa fa-eye" aria-hidden="true"></i>
        </button>

        <button class="edit-btn btn custom-tooltip" *ngIf="isUpdate && !fromManager" [disabled]="isButtonDisabled(params) || isCompleted" title="Edit" mat-icon-button tooltipPosition="top" (click)="onClickEdit($event)">
            <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
        </button>
    </div>
    `
})

export class ActionEditDeleteBtnRendererTechnicianSubTask implements ICellRendererAngularComp, OnDestroy {
    params: any;
    isUpdate: boolean = false;
    isDelete: boolean = false;
    isCompleted = false;
    isTechnicianScreen: boolean = false;
    fromManager: boolean = false;
    // If you want to implement the refresh method
    refresh(params: any): boolean {
        this.params = params;
        const status = params?.data?.status?.toLowerCase();
        this.isCompleted = status === 'completed' || status === 'closed' || status === 'complete' || status === 'close';
        return true;
    }

    agInit(params: any): void {
        this.params = params;
        this.isUpdate = params.isUpdate ?? false;
        this.isDelete = params.isDelete ?? false;
        const status = params?.data?.status?.toLowerCase();
        this.isCompleted = status === 'completed' || status === 'closed';
        this.isTechnicianScreen = params.isTechnicianScreen ?? false;
        this.fromManager = params?.fromManager ?? false;    
    }
    isButtonDisabled(params: any): boolean {
        // Check if canEdit function is provided and use it
        if (params?.canEdit && typeof params.canEdit === 'function') {
            const canEdit = params.canEdit(params);
            if (!canEdit) {
                return true;
            }
        }

        // For technician screen: disable if created by manager
        if (this.isTechnicianScreen && params?.data?.IsManager === true) {
            return true;
        }

        // For wosubtask (non-technician screen): check approval status
        if (!this.isTechnicianScreen) {
            const approvalDate = params?.data?.approvalDate;
            const approvedBy = params?.data?.approvedBy;
            const isApproved = params?.data?.isApproved;

            // Disable if not approved (pending or disapproved)
            if (!approvalDate || !approvedBy || isApproved === false || isApproved === 0) {
                return true;
            }
        }

        return false;
    }
    isApprovalPending(): boolean {
        // Only apply for technician screen
        if (!this.isTechnicianScreen) {
            return false;
        }

        const approvalDate = this.params?.data?.approvalDate;
        const approvedBy = this.params?.data?.approvedBy;
        const isApproved = this.params?.data?.isApproved;

        // If approval date and approved by are null, it's pending
        if (!approvalDate && !approvedBy) {
            return true;
        }

        // If it's disapproved, also disable edit
        if (approvalDate && approvedBy && (isApproved === false || isApproved === 0)) {
            return true;
        }

        return false;
    }
    onClickView($event: any): void {
        if (this.params.onClickView instanceof Function) {
            const params = {
                event: $event,
                rowData: this.params.node.data,
                index: this.params.node.rowIndex
            };
            this.params.onClickView(params);
        }
    }
    onClickEdit($event: any): void {
        if (this.params.onClickEdit instanceof Function) {
            const params = {
                event: $event,
                rowData: this.params.node.data,
                index: this.params.node.rowIndex
            };
            this.params.onClickEdit(params);
        }
    }

    onClickDelete($event: any): void {
        if (this.params.onClickDelete instanceof Function) {
            const params = {
                event: $event,
                rowData: this.params.node.data,
                index: this.params.node.rowIndex
            };
            this.params.onClickDelete(params);
        }
    }

    ngOnDestroy(): void {
        // Cleanup if necessary (optional)
    }
}
